import styles from "../../styles/performance/Disasters.module.css";
import classNames from "classnames/bind";
import disasterData from "../../data/disaster.json";
import { useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState, useCallback } from "react";

const cx = classNames.bind(styles);

export default function Disasters() {
  const disasterList = disasterData.disasters;

  // URL 파라미터 읽기 및 쓰기를 위한 훅
  const [searchParams, setSearchParams] = useSearchParams();

  // 1. URL에서 'id' 값을 가져옵니다.
  const queryId = searchParams.get("id");

  // 2. 파라미터로 받은 id가 실제 데이터에 존재하는지 검증 (방어 코드)
  const isValidId = disasterList.some((item) => item.id === queryId);

  // 3. 유효한 id면 그걸 쓰고, 없거나 이상한 값이면 첫 번째 항목을 기본값으로 사용
  const activeTab = isValidId ? queryId : disasterList[0].id;

  // 4. 탭 클릭 시 URL 쿼리 파라미터 업데이트
  const handleTabClick = (id) => {
    setSearchParams({ id });
  };

  // 화면 너비보다 메뉴 폭이 넓을 경우 스크롤 가능하게
  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(false);

  const checkScrollStatus = useCallback(() => {
    const el = containerRef.current;
    if (el) {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      setIsScrollable(scrollWidth > clientWidth);
      setShowLeftGradient(scrollLeft > 1);
      setShowRightGradient(scrollLeft + clientWidth < scrollWidth - 1);
    }
  }, []);

  useEffect(() => {
    const el = containerRef.current;

    checkScrollStatus();
    if (el) el.addEventListener("scroll", checkScrollStatus);
    window.addEventListener("resize", checkScrollStatus);

    const observer = new MutationObserver(checkScrollStatus);
    if (el) {
      observer.observe(el, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    return () => {
      if (el) el.removeEventListener("scroll", checkScrollStatus);
      window.removeEventListener("resize", checkScrollStatus);
      observer.disconnect();
    };
  }, [disasterList, checkScrollStatus]);

  const renderDisasterContent = (item) => (
    <div className={cx("reveal")}>
      <div className={cx("contentLayout")}>
        <div className={cx("disasterImgWrap")}>
          <img src={item.img} alt={item.title} />
          <p>(※이해를 돕기 위한 이미지, 실제 사건과 관련이 없습니다.)</p>
        </div>

        <div className={cx("disasterTextWrap")}>
          <p className={cx("outline")}>{item.outline}</p>

          <div className={cx("disasterSection")}>
            <h5>주요 쟁점</h5>
            <ul>
              {item.mainIssues.map((issue, index) => (
                <li key={index}>{issue}</li>
              ))}
            </ul>
          </div>

          <div className={cx("disasterSection")}>
            <h5>조정 포인트</h5>
            <ul>
              {item.adjusterPoint.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>

          <div className={cx("disasterSection")}>
            <h5>결과</h5>
            <p className={cx("resultText")}>{item.result}</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={cx("disastersWrap")}>
      <div className={cx("title")}>
        <h4>각종 재난사고</h4>
      </div>

      <div className={cx("disasterBtnContainer")}>
        <div
          className={cx("disasterBtnWrap", { scrollable: isScrollable })}
          ref={containerRef}
        >
          {disasterList.map((item) => (
            <div
              key={item.id}
              className={cx("disasterBtn", { active: activeTab === item.id })}
              onClick={() => handleTabClick(item.id)}
            >
              {item.title}
            </div>
          ))}
        </div>
        <div
          className={cx("gradient", "leftGradient", { show: showLeftGradient })}
        ></div>
        <div
          className={cx("gradient", "rightGradient", {
            show: showRightGradient,
          })}
        ></div>
      </div>

      <div className={cx("disasterContentArea")}>
        {disasterList.map((item) => (
          <div
            key={item.id}
            className={cx("disasterDesc", { hidden: activeTab !== item.id })}
          >
            {renderDisasterContent(item)}
          </div>
        ))}
      </div>
    </div>
  );
}
